import {
  Button,
  Chip,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { QRCodeSVG } from "qrcode.react";
import React from "react";
import { getUserOnly } from "../../../services/expositor/subscriptions.service";
import { deleteSubscription } from "../../../services/subscriptions.service";
import { ModalComponent, useModal } from "../../../ui-components/Modal";
import SectionTitle from "../../../ui-components/SectionTitle";
import { parseDateLocale } from "../../../utils/parseDate";

const space: any = {
  1: "Compartilhado",
  2: "Exclusivo",
  shared: "Compartilhado",
  exclusive: "Exclusivo",
  "1_tendas": "1 Tenda",
  "2_tendas": "2 Tendas",
  autoral: "Marcas Autorais",
  alimentacao: "Praça de Alimentação",
};

const tablechair = {
  1: "Sem mesa/cadeira extra",
  2: "Mesa extra",
  3: "Cadeira extra",
  4: "Mesa/cadeira extra",
};

export default function PreSubscriptions() {
  const [userSubscriptions, setUserSubscriptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [selectedSub, setSelectedSub] = React.useState<any>({});
  const {
    open: openPix,
    handleOpen: handleOpenPix,
    handleClose: handleClosePix,
  } = useModal();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  async function syncSubscriptions() {
    setLoading(true);
    setUserSubscriptions(await getUserOnly());
    setLoading(false);
  }

  React.useEffect(() => {
    syncSubscriptions();
  }, []);

  return (
    <>
      <ModalComponent
        open={openPix}
        handleClose={handleClosePix}
        maxWidth={isXs ? 320 : 420}
        sx={{ width: isXs ? 320 : 420 }}
        autoHeight
      >
        {selectedSub?.pix_code && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              p: 1,
              gap: 1,
            }}
          >
            <img
              style={{ marginBottom: "8px", height: 64, width: "auto" }}
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Logo%E2%80%94pix_powered_by_Banco_Central_%28Brazil%2C_2020%29.svg/2560px-Logo%E2%80%94pix_powered_by_Banco_Central_%28Brazil%2C_2020%29.svg.png"
              alt=""
            />
            <QRCodeSVG value={selectedSub.pix_code} size={isXs ? 280 : 320} />
          </Box>
        )}
      </ModalComponent>
      <Grid container>
        <Paper
          sx={{
            p: { xs: 2, sm: 3 },
            width: "100%",
            borderRadius: 3,
            border: "1px solid #e2e8f0",
            boxShadow:
              "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
          }}
        >
          <SectionTitle title={"Inscrições aprovadas:"} />
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            userSubscriptions &&
            userSubscriptions
              .filter((x) => x.status_id === 1)
              .map((sub) => (
                <Grid pb="10px" key={sub.id}>
                  <Grid>
                    <Paper
                      sx={{
                        borderLeft: sub.is_paid
                          ? "6px solid #22c55e"
                          : "6px solid #ef4444",
                        p: { xs: 2, sm: 2.5 },
                        borderRadius: 2,
                        border: "1px solid #e2e8f0",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
                        transition: "box-shadow 0.2s ease, transform 0.2s ease",
                        "&:hover": {
                          boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
                          transform: "translateY(-1px)",
                        },
                      }}
                    >
                      <Grid
                        display={"flex"}
                        justifyContent="space-between"
                        alignItems={"center"}
                        sx={{ gap: { xs: 2, sm: 3 }, flexWrap: "wrap" }}
                      >
                        <Grid>
                          <Typography
                            variant="h6"
                            sx={{ fontWeight: 600, color: "#24324D" }}
                          >
                            Evento: Praceria
                          </Typography>
                          <Chip
                            label={
                              sub.is_paid ? "Pago" : "Aguardando pagamento"
                            }
                            color={sub.is_paid ? "success" : "warning"}
                            variant="outlined"
                            sx={{
                              mt: 0.5,
                              borderRadius: "9999px",
                              fontWeight: 600,
                            }}
                          />
                          <Typography
                            variant="h6"
                            sx={{ color: "#22c55e", fontWeight: 600 }}
                          >
                            Valor Total da Inscrição: R${sub.amount},00
                          </Typography>
                          <Typography>
                            Pagamento confirmado pelo evento:{" "}
                            {sub.is_paid ? "Sim" : "Não"}
                          </Typography>
                          <Typography>
                            Seu número no mapa do evento:{" "}
                            {sub.event_space
                              ? sub.event_space
                              : "Ainda não foi adicionado, aguarde."}
                          </Typography>

                          <Typography my={2}>Suas Escolhas:</Typography>

                          <Typography>
                            <span style={{ color: "#24324D", fontWeight: 600 }}>
                              Data de início:{" "}
                            </span>
                            {parseDateLocale(sub.start_date)}
                          </Typography>
                          <Typography>
                            <span style={{ color: "#24324D", fontWeight: 600 }}>
                              Data de fim:{" "}
                            </span>
                            {parseDateLocale(sub.end_date)}
                          </Typography>
                          <Typography>
                            <span style={{ color: "#24324D", fontWeight: 600 }}>
                              Tipo de espaço:{" "}
                            </span>
                            {space[sub.space_type]}
                          </Typography>
                          <Typography>
                            <span style={{ color: "#24324D", fontWeight: 600 }}>
                              Mesa extra:{" "}
                            </span>
                            {sub.extra_table ? "Sim" : "Não"}
                          </Typography>
                          <Typography>
                            <span style={{ color: "#24324D", fontWeight: 600 }}>
                              Quantas mesas:{" "}
                            </span>
                            {sub.table_quantity || 0}
                          </Typography>
                          <Typography>
                            <span style={{ color: "#24324D", fontWeight: 600 }}>
                              Cadeira Extra:{" "}
                            </span>
                            {sub.extra_chair ? "Sim" : "Não"}
                          </Typography>
                          <Typography>
                            <span style={{ color: "#24324D", fontWeight: 600 }}>
                              Quantas cadeiras:{" "}
                            </span>
                            {sub.chair_quantity || 0}
                          </Typography>
                          <Typography>
                            <span style={{ color: "#24324D", fontWeight: 600 }}>
                              Itens:{" "}
                            </span>
                            {sub.items}
                          </Typography>
                          <Typography>
                            <span style={{ color: "#24324D", fontWeight: 600 }}>
                              Observação:{" "}
                            </span>
                            {sub.notes}
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: "0.875rem",
                              mt: 1,
                              background: "#f1f5f9",
                              border: "1px solid #e2e8f0",
                              borderRadius: "9999px",
                              textAlign: "center",
                              color: "#64748b",
                              px: 2,
                              py: 0.5,
                            }}
                          >
                            Última atualização:{" "}
                            {parseDateLocale(sub.updated_at)}
                          </Typography>
                        </Grid>
                        <Grid
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                          }}
                        >
                          {!sub.is_paid && (
                            <Button
                              onClick={() => {
                                setSelectedSub(sub);
                                handleOpenPix();
                              }}
                              variant="contained"
                              sx={{
                                backgroundColor: "#24324D",
                                color: "#ffffff",
                                fontWeight: 600,
                                borderRadius: 2,
                                px: 2.5,
                                py: 1,
                                textTransform: "none",
                                boxShadow: "0 2px 8px rgba(36,50,77,0.25)",
                                "&:hover": {
                                  backgroundColor: "#1a2538",
                                  transform: "translateY(-1px)",
                                  boxShadow: "0 6px 14px rgba(36,50,77,0.35)",
                                },
                                transition: "all 0.2s ease-in-out",
                              }}
                            >
                              Pagar Inscrição
                            </Button>
                          )}
                          {/* <Button variant="contained">
                            Alterar Informações
                          </Button> */}
                          <Button
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Você realmente deseja cancelar esta inscrição já aprovada? Essa operação é irreversível!",
                                )
                              ) {
                                deleteSubscription(sub.id).then(() => {
                                  alert("Inscrição apagada com sucesso!");
                                  window.location.reload();
                                });
                              } else {
                                console.log("cancelado");
                              }
                            }}
                            variant="outlined"
                            sx={{
                              color: "#24324D",
                              borderColor: "#24324D",
                              fontWeight: 600,
                              borderRadius: 2,
                              px: 2.5,
                              py: 1,
                              textTransform: "none",
                              "&:hover": {
                                borderColor: "#1a2538",
                                color: "#1a2538",
                              },
                            }}
                          >
                            Apagar Inscrição
                          </Button>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              ))
          )}
        </Paper>
      </Grid>
    </>
  );
}
